import CircularProgress from '@mui/material/CircularProgress';

import {
  CIRCULAR_PROGRESS_SIZE_PX,
  CIRCULAR_PROGRESS_THICKNESS,
} from 'theme/components/circular-progress';
import {
  ProgressRingLabel,
  ProgressRingRoot,
} from 'ui/progress-ring/progress-ring.styles';
import type { ProgressRingProps } from 'ui/progress-ring/progress-ring.types';
import { useProgressRing } from 'ui/progress-ring/use-progress-ring';

const ProgressRing = ({
  value: valueProp = 0,
  size = 'medium',
  color = 'secondary',
  label,
  'aria-label': ariaLabel,
  'data-testid': dataTestId,
}: ProgressRingProps) => {
  const { value, valueText, labelId } = useProgressRing(valueProp);
  const nameProps = label
    ? { 'aria-labelledby': labelId }
    : { 'aria-label': ariaLabel ?? valueText };

  return (
    <ProgressRingRoot ringColor={color} data-testid={dataTestId}>
      <CircularProgress
        variant="determinate"
        value={value}
        color="inherit"
        size={CIRCULAR_PROGRESS_SIZE_PX[size]}
        thickness={CIRCULAR_PROGRESS_THICKNESS}
        enableTrackSlot
        aria-valuetext={valueText}
        {...nameProps}
      />
      {label && (
        <ProgressRingLabel id={labelId} ringColor={color} ringSize={size}>
          {label}
        </ProgressRingLabel>
      )}
    </ProgressRingRoot>
  );
};

export default ProgressRing;
